import axios from "axios";
import router from "./router/router";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

const api = axios.create({
  baseURL: process.env.VUE_APP_APIHOST,
  Authorization: "Token " + cookies.get("CPsession"),
});

const clearAuthorizationHeader = () => {
  if (api.defaults.headers && api.defaults.headers.Authorization) {
    delete api.defaults.headers.Authorization;
  }

  if (
    api.defaults.headers &&
    api.defaults.headers.common &&
    api.defaults.headers.common.Authorization
  ) {
    delete api.defaults.headers.common.Authorization;
  }
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Network and CORS failures carry no response at all - reading it here
    // used to throw inside the interceptor and mask the original error.
    const detail = error?.response?.data?.detail;

    if (
      detail === "token_expired" ||
      detail === "Nieprawidłowy token logowania."
    ) {
      cookies.remove("CPsession");
      clearAuthorizationHeader();
      router.push("/");
    }

    return Promise.reject(error);
  }
);

export default api;
